import React, { useState, useRef, Fragment } from 'react';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { Icon } from '@sas/nova-commons/components/Icon';
import { InformationStatus } from '@sas/react-svg';
import { Popover } from '@sas/nova-commons/components/Popover';
export const WarningIcon = ({ warning, iconStyle }) => {
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const refIcon = useRef(null);
    const refReturnFocus = useRef(false);
    const dt = useDesignTokens();
    return warning ? (React.createElement(Fragment, null,
        React.createElement(Icon, { ref: refIcon, style: iconStyle, tooltip: warning, icon: InformationStatus, onPress: () => {
                setTooltipVisible(true);
            } }),
        React.createElement(Popover, { focusLockProps: {
                onDeactivation() {
                    if (refReturnFocus.current) {
                        refReturnFocus.current = false;
                        setTimeout(() => {
                            var _a;
                            (_a = refIcon.current) === null || _a === void 0 ? void 0 : _a.focus();
                        });
                    }
                },
            }, onEscape: () => {
                refReturnFocus.current = true;
            }, returnFocus: false, referenceElementRef: refIcon, isOpen: tooltipVisible, placement: "bottom", onClose: () => setTooltipVisible(false), focusable: true, style: {
                color: dt.reportTokens.text.basic.fg,
            } }, warning))) : null;
};
